export default __webpack_public_path__ + "static/media/16.86775f82.png";